import cityCaptainApp from "./cityCaptainApp.component";

const cityCaptainAppModule = angular
  .module("app.components.cityCaptainApp", [])
  .component("cityCaptainApp", cityCaptainApp);

export default cityCaptainAppModule;



// WEBPACK FOOTER //
// ./src/components/cityCaptainApp/cityCaptainApp.module.js